export default __webpack_public_path__ + "static/media/caf-logo.b3fb5742.svg";